import React, { HTMLInputTypeAttribute } from 'react'

import './input.css'

export const Input = ({
    value,
    onChange,
    style,
    className,
    label,
    type,
    ...rest
}: {
    value: string | number | Date | any,
    onChange: Function,
    style?: any,
    label?: string;
    className?: string,
    rest?: any,
    type?: HTMLInputTypeAttribute
}) => {

    return (
        <div>
            {label && (
                <div style={{
                    textAlign: 'left',
                    paddingLeft: '1rem',
                    opacity: 0.8,
                    fontSize: '0.8rem'
                }}>
                    {label}
                </div>
            )}
            <input
                type={type}
                className={'input'}
                style={style}
                value={value}
                onChange={(e) => onChange(e)}
                {...rest}
            />
        </div>
    )
}

export default Input;